export const generateResponsibilities = (t) => [
  {
    id: 1,
    label: t('operatorForm.fields.resourceStatus'),
    name: 'isResourceStatus',
    value: false
  },
  {
    id: 2,
    label: t('operatorForm.fields.cleaningTaskStopped'),
    name: 'isCleaningTaskStopped',
    value: false
  },
  {
    id: 3,
    label: t('operatorForm.fields.emergencyStop'),
    name: 'isEmergencyStop',
    value: false
  },
  {
    id: 4,
    label: t('operatorForm.fields.serviceNeeded'),
    name: 'isServiceNeeded',
    value: false
  },
  {
    id: 5,
    label: t('operatorForm.fields.batteryDeepDischarge'),
    name: 'isBatteryDeepDischarge',
    value: false
  },
  {
    id: 6,
    label: t('operatorForm.fields.cleaningTaskFinished'),
    name: 'isCleaningTaskFinished',
    value: false
  },
  {
    id: 7,
    label: t('operatorForm.fields.errorOccurred'),
    name: 'isErrorOccurred',
    value: false
  },
  {
    id: 8,
    label: t('operatorForm.fields.locationStatus'),
    name: 'isLocationStatus',
    value: false
  }
];
